import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';
import { useUserContext } from '../Components/StateContext/UserContext';

interface ConfigTile {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
}

const renderTile = (tile: ConfigTile, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? 'ods-grid__column--6 ods-grid__column--4-breakpoint-medium ods-color-text-grayscale-10' : 'ods-grid__column--6 ods-grid__column--4-breakpoint-medium'}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const ConfigView: React.FC<RouteComponentProps> = () => {
  const { userRoles } = useUserContext();
  const isAdmin = userRoles.includes('admin');
  // Localadmins reach Konfigurasjon only for Bilder (tagging/uploading event photos); the
  // exam/athletics config remains admin-only.
  const isAdminOrLocalAdmin = isAdmin || userRoles.includes('localadmin');

  const tiles: ConfigTile[] = [
    { label: 'Eksamen', icon: 'ods-icon--document', href: '/config/exam', disabled: !isAdmin },
    { label: 'Friidrett', icon: 'ods-icon--calendar', href: '/config/athletics', disabled: !isAdmin },
    // TODO: Bilder midlertidig skjult
    // { label: 'Bilder', icon: 'ods-icon--picture', href: '/config/bilder', disabled: !isAdminOrLocalAdmin },
  ];

  return (
    <>
      <OKomBreadcrumb path='Konfigurasjon'></OKomBreadcrumb>
      <div className="ods-grid ods-grid--gap ods-grid--center ods-margin-top-11 ods-text--align-center">
        {tiles.map((tile, i) => renderTile(tile, i))}
      </div>
    </>
  );
};

export default withRouter(ConfigView);
